<template>
<drawer :opened.sync="visible" class="qc-data-import-drawer">
  <template slot="header">删除质控数据</template>
  <template slot="body">
    <el-form v-if="visible" ref="form" :model="model" :rules="rules" label-width="85px" @keydown.native.enter.prevent>
      <el-form-item label="站房名称" prop="siteName">
        {{site.name}}
      </el-form-item>

      <el-form-item label="日期选择" prop="dataTime">
        <el-date-picker
          v-model="model.dataTime"
          :clearable="false"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>

      <el-form-item label="质控类型" prop="type">
        <el-cascader
          v-model="model.type"
          :options="qcDeviceList"
          :props="{expandTrigger:'hover'}"
          style="width:220px;"
        />
      </el-form-item>
    </el-form>
  </template>

  <template slot="footer">
    <el-button type="danger" class="btn save-btn" @click="handleDelete">删除</el-button>
    <a class="cancel-btn btn" @click="handleClose">关闭</a>
  </template>
</drawer>
</template>

<script>
export default {
  name: 'QCDataDelete',
  props: {
    site: Object,
    qcDeviceList: Array,
    query: Object
  },
  data () {
    return {
      token: '',
      visible: false,
      deviceListStr: '',
      model: {
        siteId: '',
        dataTime: new Date().format('YYYY-MM-DD'),
        type: []
      },
      rules: {
        dataTime: [{
          required: true,
          trigger: 'blur',
          message: '请输入日期'
        }]
      }
    }
  },
  methods: {
    open () {
      this.initModel()
      this.visible = true
    },
    initModel () {
      let {model, query} = this
      model.siteId = this.site.id
      model.dataTime = new Date().format('YYYY-MM-DD')
      model.type = [query.deviceCategoryId, query.checkItemId]
    },
    handleClose () {
      this.visible = false
    },
    handleDelete () {
      this.$confirm(`此操作将永久删除'${this.model.dataTime}'质控数据, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        let model = JSON.parse(JSON.stringify(this.model))
        let type = model.type
        model.qualityFactorCategoryId = type[0]
        model.type = type[1]

        this.$api.QCAnalysis.delete(model).then(data => {
          this.handleClose()
          this.$emit('deleted-success')
        }).catch(console.error)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/QCDataDelete.vue